<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item :label="($t('JUMP_TARGET'))" prop="jumpType">
        <dict-select v-model="form.data.jumpType" dict-code="JUMP_TARGET"/>
      <a-form-model-item label="系列" prop="type" v-if="form.data.jumpType==='SERIES'">
        <goods-series-select v-model="form.data.targetId"/>
      </a-form-model-item>
    </a-form-model-item>
    <a-form-model-item prop="type" v-if="form.data.jumpType==='GOODS'">
     <a-form-model-item label="商品选择" prop="type">
       <img-goods-select type="NORMAL" v-model="form.data.targetId"/>
    </a-form-model-item>
    </a-form-model-item>
    <a-form-model-item label="活动" prop="type" v-if="form.data.jumpType==='ACTIVITY'">
      <lottery-select v-model="form.data.targetId"/>
    </a-form-model-item>
    <a-form-model-item label="分类" prop="type" v-if="form.data.jumpType==='CATEGORY'">
      <goods-category-select v-model="form.data.targetId"/>
    </a-form-model-item>
    <a-form-model-item>
      <a-space>
        <a-button type="primary" v-if="!indexPosterId" @click="onAdd">创建</a-button>
        <a-button type="primary" v-if="indexPosterId" @click="onUpdate">更新</a-button>
      </a-space>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import {
  _queryIndexPoster,
  _addIndexPoster,
  _updateIndexPosterJumpTarget,
} from '@/api/indexPosterApi';

import GoodsSeriesSelect from '@/components/contentSelector/GoodsSeriesSelect.vue';
import moment from 'moment';
import DictSelect from '../../../components/DictSelect.vue';
import LotterySelect from '@/components/contentSelector/LotterySelect.vue';
import ImgGoodsSelect from '@/components/contentSelector/ImgGoodsSelect.vue';
import GoodsCategorySelect from '@/components/contentSelector/GoodsCategorySelect.vue';

async function getIndexPoster() {
  const result = await _queryIndexPoster(this.indexPosterId);
  if (result) {
    this.form.data.jumpType = result.jumpType;
    this.form.data.targetId = result.targetId;
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addIndexPoster({
        jumpType: this.form.data.jumpType,
        targetId: this.form.data.targetId,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success(this.$t('ADD_SUCCESS'));
          this.onSubmitHandler();
        }
      }
    }
  });
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateIndexPosterJumpTarget(this.indexPosterId, {
        jumpType: this.form.data.jumpType,
        targetId: this.form.data.targetId,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success(this.$t('UPDATE_SUCCESS'));
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'IndexPosterJumpEdit',
  components: {
    DictSelect,
    GoodsSeriesSelect,
    LotterySelect,
    ImgGoodsSelect,
    GoodsCategorySelect,
  },
  props: {
    indexPosterId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    indexPosterId() {
      if (this.indexPosterId) {
        this.getIndexPoster();
      }
    },
  },
  data() {
    return {
      form: {
        data: {
          jumpType: '',
          targetId: '',
        },
        title: '',
        rules: {
          jumpType: [{
            required: true,
            trigger: 'blur',
          }],
          targetId: [{
            required: true,
            trigger: 'blur',
          }],
        },
      },
      // hashReset: true,
      // tempData: 'IN_SELL',
      // category: {
      //   data: [],
      // },
      // form: {
      //   data: {
      //     jumpType: '',
      //     targetId: '',
      //     status: '',
      //     categoryId: '',
      //     topImage: '',
      //     sellStartAt: `${moment().format('YYYY-MM-DD')}T00:00:00`,
      //   },
      //   title: '',
      //   rules: {
      //     status: [{ required: true, trigger: 'blur' }],
      //     targetId: [{ required: true, trigger: 'blur' }],
      //     brandId: [{ required: true, trigger: 'blur' }],
      //     topImage: [{ required: true, trigger: 'blur' }],
      //     sellStartAt: [{ required: true, trigger: 'blur' },
      //       {
      //         type: 'date', message: '需以日期形式展示', trigger: 'blur',
      //       }],
      //   },
      // },
      // filterData: {
      //   skuGoodsStatus: '',
      //   categoryId: '',
      //   goodsId: '',
      // },
    };
  },
  computed: {
  },
  created() {
    if (this.indexPosterId) {
      this.getIndexPoster();
    }
  },
  methods: {
    moment,
    onAdd,
    onUpdate,
    onCancel,
    getIndexPoster,
  },
};
</script>

<style scoped lang="scss">

</style>
